<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="storage">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <div class="accountsReceive">
                <van-button
                    @click="goListFun"
                    class="xs_btn"
                    size="small"
                    plain
                    type="danger"
                >
                    库存查看
                </van-button>
                <timeNodeFiltering ref="timeNodeFiltering" @selectNodeCallback="getData"></timeNodeFiltering>
                <div class="main">
                    <div class="top">
                        <div class="header">
                            <div class="item item0">
                                <p class="describe">
                                    昨日库存
                                </p>
                                <p class="num">
                                    {{ detailVal.yesterday_stock }}
                                </p>
                            </div>
                            <div class="border_1"></div>
                            <div class="item">
                                <p class="describe2">
                                    入库数量
                                </p>
                                <p class="num2">
                                    {{ detailVal.current_inbound }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    出库数量
                                </p>
                                <p class="num2">
                                    {{ detailVal.current_outbound }}
                                </p>
                            </div>
                            <div class="item">
                                <p class="describe2">
                                    当日库存
                                </p>
                                <p class="num2">
                                    {{ detailVal.current_stock }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="chart-con">
                        <div id="shipment-chart"></div>
                    </div>
                    <div class="split"></div>
                    <div class="chart-con">
                        <!-- <div class="btn_box">
                            <van-button size="small" type="danger">
                                本周趋势
                            </van-button>
                        </div> -->
                        <div id="balance-chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </v-touch>
</template>

<script>
import timeNodeFiltering from '@/components/timeNodeFiltering/index.vue';
export default {
    components: { timeNodeFiltering },
    props: {},
    data() {
        return {
            navData: {
                title: '储运日报（鸡西）',
                leftText: '',
                rightText: '',
                leftArrow: true,
            },
            // 唤起日期选择的日期key
            dateKey: '',
            tableData: [],
            listData: [], // 列表数据
            detailVal: {
                yesterday_stock: 0,
                current_stock: 0,
                current_inbound: 0,
                current_outbound: 0,
            },
        };
    },
    mounted() {},
    methods: {
        goListFun() {
            this.$router.isBack = 2;
            this.$router.replace({
                path: '/storageAndTransportationDailyList',
                query: {
                    tableData: JSON.stringify(this.tableData),
                    date: this.$refs.timeNodeFiltering.startDate,
                },
            });
        },
        // 获取数据
        getData(start_date, end_date) {
            this.$toast.loading({ overlay: true, duration: 0 });
            const path = `/interfaceApi/report/report/transport/day_report/${start_date}?end_date=${end_date}`;
            this.$axios.get(path)
                .then(res => {
                    if (res) {
                        this.detailVal = res.total;
                        this.tableData = res.details;
                        this.lineColumn('balance-chart', res.days);
                        this.lineColumn2('shipment-chart', res.days);
                    }
                    this.$toast.clear();
                });
        },
        lineColumn(obj, listData) {
            const data = {
                xAxis: [],
                list1: [],
                list2: [],
                list3: [],
            };

            listData.forEach(item => {
                data.xAxis.push(item.report_date.substring(5, 10));
                data.list1.push(item.current_inbound);
                data.list2.push(item.current_outbound);
                data.list3.push(item.current_stock);
            });
            const lineColumnChart = window.$globalHub.$echarts.init(document.getElementById(obj));
            const colors = ['#ED6967', '#5D7092'];
            const option = {
                title: {
                    text: '出入库对比',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: false,
                grid: {
                    left: 10,
                    top: 50,
                    right: 10,
                    bottom: 0,
                    containLabel: true,
                },
                xAxis: [{
                    // type:'category',
                    data: data.xAxis,
                    boundaryGap: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(133,133,133,0.2)',
                        },
                    },
                    splitArea: {
                        color: '#f00',
                        lineStyle: {
                            color: '#f00',
                        },
                    },
                    axisLabel: {
                        color: '#979EA7',
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                yAxis: [
                    {
                        name: '',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.1)',
                                width: 0.5,
                                type: 'dashed',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    {
                        name: '',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                                width: 0.5,
                                type: 'solid',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '当日入库',
                        barWidth: 15,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: colors[0],
                                },
                                {
                                    offset: 1,
                                    color: colors[0],
                                },
                                ]),
                            },
                        },
                        data: data.list1,
                    },
                    {
                        name: '当日出库',
                        type: 'bar',
                        barWidth: 15,
                        yAxisIndex: 0,
                        stack: '',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: colors[1],
                                },
                                {
                                    offset: 1,
                                    color: colors[1],
                                },
                                ]),
                            },
                        },
                        data: data.list2,
                    },
                    {
                        name: '当日库存',
                        type: 'line',
                        // smooth: true,
                        showSymbol: true,
                        symbolSize: 8,
                        lineStyle: {
                            normal: {
                                color: '#FA8436',
                                width: 2,
                            },
                        },
                        yAxisIndex: 1,
                        label: {
                            show: false,
                            position: 'top',
                            textStyle: {
                                color: '#FC9343',
                            },
                        },
                        itemStyle: {
                            color: '#6c50f3',
                            borderColor: '#fff',
                            borderWidth: 2,
                            shadowColor: '#FA8436',
                            shadowBlur: 0,
                            shadowOffsetY: 2,
                            shadowOffsetX: 2,
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        data: data.list3,
                    },
                ],
            };
            lineColumnChart.setOption(option);
        },

        lineColumn2(obj, listData) {
            const data = {
                xAxis: [],
                list: [],
            };
            listData.forEach(item => {
                data.xAxis.push(item.report_date.substring(5, 10));
                data.list.push(item.current_outbound);
            });
            const lineColumnChart = window.$globalHub.$echarts.init(document.getElementById(obj));
            const option = {
                title: {
                    text: '发运量',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: false,
                grid: {
                    left: 10,
                    top: 40,
                    right: 10,
                    bottom: 0,
                    containLabel: true,
                },
                xAxis: [{
                    // type:'category',
                    data: data.xAxis,
                    boundaryGap: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(133,133,133,0.2)',
                        },
                    },
                    splitArea: {
                        color: '#f00',
                        lineStyle: {
                            color: '#f00',
                        },
                    },
                    axisLabel: {
                        color: '#979EA7',
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                yAxis: [
                    {
                        name: '',
                        nameLocation: 'end',
                        nameTextStyle: {
                            color: '#979EA7',
                            padding: '',
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.1)',
                                width: 0.5,
                                type: 'dashed',
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(133,133,133,0.2)',
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: '#979EA7',
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '发货量',
                        type: 'line',
                        showSymbol: true,
                        symbolSize: 8,
                        lineStyle: {
                            normal: {
                                color: '#FA8436',
                                width: 2,
                            },
                        },
                        yAxisIndex: 0,
                        label: {
                            show: false,
                            position: 'top',
                            textStyle: {
                                color: '#FC9343',
                            },
                        },
                        itemStyle: {
                            color: '#6c50f3',
                            borderColor: '#fff',
                            borderWidth: 2,
                            shadowColor: '#FA8436',
                            shadowBlur: 0,
                            shadowOffsetY: 2,
                            shadowOffsetX: 2,
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        areaStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#FA8436',
                                }, {
                                    offset: 1,
                                    color: '#fff',
                                }], false),
                            },
                        },
                        data: data.list,
                    },
                ],
            };
            lineColumnChart.setOption(option);
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
    },
};
</script>
<style lang="stylus" scoped>
.storage
    width 100%
    height 100%
    .accountsReceive
        background #fff
        width 100%
        height calc(100% - 70rpx)
        position: relative
        .xs_btn
            position: absolute
            top 12rpx
            right 12rpx
        >>>.timeNodeFiltering
            .search-conditions-con
                height auto
                flex-direction column
                align-items: initial;
                .van-radio-group
                    flex-shrink: 0;
                    height: 13.8667vw;
                .search-conditions-month
                    width 100%;
                    margin 10rpx 0
                    font-size: 16rpx;
                    height: 12vw;
                    box-shadow: 1px 1px 4px 0px rgba(0,0,0,0.2);
                    border-radius: 1.0667vw;
                    padding: 2.6667vw 5.3333vw;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    line-height: 6.6667vw;
                    background: #f0f0f0;
                    &:before
                        position: initial
                        margin-right 20rpx
                        font-size: 18rpx
                    >span
                        font-family: '微软雅黑';
        .charts_header
            margin 12rpx 30rpx
            .van-tabs__nav
                margin 0
        .main
            height calc(100% - 125rpx)
            overflow-y auto
            .top
                padding 0 10rpx 10rpx 10rpx
                h4
                    margin-top 10rpx
                    span
                        font-size 12rpx
                        color #979EA7
                .header
                    display flex
                    margin-top 10rpx
                    background repeating-linear-gradient(to left, #F79187, #EA5D5D)
                    border-radius 4rpx
                    padding 5rpx 0
                    .border_1
                        flex 1
                        height 40rpx
                        margin-top 15rpx
                        background #FC8785
                    .item
                        flex-shrink 0
                        width calc(100%/4.02)
                        text-align center
                        padding 3rpx 0 5rpx 0
                        color #fff
                        .num
                            font-size 24rpx
                        .num2
                            font-size 20rpx
                            margin-top 6rpx
                        .describe
                            font-size 18rpx
                            margin-bottom 3rpx
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            line-height 25rpx
                        .describe2
                            font-size 16rpx
                            margin-bottom 3rpx
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            line-height 25rpx
            .split
                background #F0F0F0
                height 15rpx
            .chart-con
                padding 10rpx
                position relative
                .btn_box
                    position absolute
                    right 4rpx
                    top 4rpx
                    z-index 99
                h4
                    margin 10rpx 0
                #balance-chart
                    height 250rpx
                #shipment-chart
                    height 270rpx
</style>
